import { gql } from '@apollo/client';
import { apolloClient } from '../config/apollo-client';

// GraphQL query for fetching all providers
export const GET_ALL_PROVIDERS_QUERY = gql`
  query GetAllProviders {
    findAllProviders {
      id
      name
      agentName
      isActive
    }
  }
`;

// Types for the response
export interface Provider {
  id: number;
  name: string;
  agentName: string;
  isActive: boolean;
}

export interface GetAllProvidersResponse {
  findAllProviders: Provider[];
}

// GetAllProviders service class
export class GetAllProvidersService {
  private static instance: GetAllProvidersService;

  private constructor() {}

  public static getInstance(): GetAllProvidersService {
    if (!GetAllProvidersService.instance) {
      GetAllProvidersService.instance = new GetAllProvidersService();
    }
    return GetAllProvidersService.instance;
  }

  // Fetch all providers
  async getAllProviders(): Promise<Provider[]> {
    try {
      const { data } = await apolloClient.query<GetAllProvidersResponse>({
        query: GET_ALL_PROVIDERS_QUERY,
        fetchPolicy: 'network-only',
      });
      return data.findAllProviders;
    } catch (error: any) {
      console.error('Error fetching providers:', error);
      if (error.graphQLErrors) {
        error.graphQLErrors.forEach((err: any) => {
          console.error('GraphQL Error:', err.message);
          console.error('Locations:', err.locations);
          console.error('Path:', err.path);
        });
      }
      if (error.networkError) {
        console.error('Network Error:', error.networkError);
      }
      throw error;
    }
  }
}

// Export singleton instance
export const getAllProvidersService = GetAllProvidersService.getInstance();

// Export convenience function
export async function getAllProviders(): Promise<Provider[]> {
  return getAllProvidersService.getAllProviders();
}
